import React, { Component } from 'react';
import { metadata, studies, utils } from 'ohif-core';

import ConnectedViewer from './ConnectedViewer.js';
import PropTypes from 'prop-types';
import { extensionManager } from './../App.js';
import qs from 'query-string';
import { apis } from '../api/index.js';
import ImageError from '../components/Error/ImageError.js';

const { OHIFStudyMetadata } = metadata;
const { retrieveStudiesMetadata } = studies;
const { studyMetadataManager, updateMetaDataManager } = utils;

class ViewerRetrieveStudyData extends Component {
  constructor(props) {
    super(props);

    const search = qs.parse(window.location.search);
    this.state = {
      ...search,
      studies: null,
      error: null,
      detailList4StudyImgList: [],
      tubeStudyDetail: {},
      applicationInfo: {},
    };
  }
  static propTypes = {
    studyInstanceUids: PropTypes.array.isRequired,
    seriesInstanceUids: PropTypes.array,
    sopInstanceUids: PropTypes.array,
    server: PropTypes.object,
    setAIProductDetailInfo: PropTypes.func,
    setAiProductHeatmapData: PropTypes.func,
    layout: PropTypes.object.isRequired,
    setViewportSpecificData: PropTypes.func.isRequired,
    viewportSpecificData: PropTypes.object.isRequired,
    setApplicationData: PropTypes.func.isRequired,
    applicationInfo: PropTypes.object,
  };

  async componentDidMount() {
    // const cityJson = await apis.getCityjson();
    // localStorage.setItem('cityJson', JSON.stringify(cityJson));

    // TODO: Avoid using timepoints here
    const { server } = this.props;
    const { from } = this.state;
    if (from === 'aiproduct') {
      const { id, type } = this.state;
      const post = { id, type };
      let ids = [];
      await apis.detailList4Study(post).then(res => {
        if (res.code === '0') {
          ids = ids.concat(res.data);
          this.setState({ detailList4StudyImgList: res.data });
          this.props.setAIProductDetailInfo(res.data);
          this.props.setAiProductHeatmapData(res.data[0].ais);
        }
      });
      if (ids.length === 0) return;
      try {
        let studies = [];
        for (let i = 0; i < ids.length; i++) {
          if (ids[i] && ids[i].studyUid) {
            const simpleStudy = await retrieveStudiesMetadata(
              server,
              [ids[i].studyUid],
              [ids[i].seriesUid],
              [ids[i].sopInstanceId]
            );
            studies.push(simpleStudy[0]);
          }
        }
        this.setStudies(studies);
      } catch (err) {
        this.setState({ error: true });

        // TODO: Handle gracefully instead of throwing?
        throw new Error(err);
      }
    } else if (from === 'aiqc') {
      let { objects } = this.state;
      objects = objects ? JSON.parse(objects)[0] : null;
      try {
        const simpleStudy = await retrieveStudiesMetadata(
          server,
          [objects.StudyUid],
          [objects.SeriesUid],
          [objects.ObjectUid]
        );
        studies.push(simpleStudy[0]);

        this.setStudies(studies);
      } catch (err) {
        this.setState({ error: true });

        // TODO: Handle gracefully instead of throwing?
        throw new Error(err);
      }
    } else if (from === 'screening') {
      const { tubeId } = this.state;
      let ids = {};
      await apis.tubeStudyDetail(tubeId).then(res => {
        if (res.code === '0') {
          ids = res.data;
          this.setState({ tubeStudyDetail: ids });
          this.props.setApplicationData(ids);
        }
      });

      try {
        let studies = [];
        const dicomList = ids.dicomList;
        for (let i = 0; i < dicomList.length; i++) {
          const simpleStudy = await retrieveStudiesMetadata(
            server,
            [ids.studyUid],
            [dicomList[i].seriesUid],
            [dicomList[i].sopInstanceId]
          );
          studies.push(simpleStudy[0]);
        }
        this.setStudies(studies);
      } catch (err) {
        this.setState({ error: true });

        // TODO: Handle gracefully instead of throwing?
        throw new Error(err);
      }
    } else if (from === 'report') {
      const applicationInfo = await this.getApplicationInfo();
      this.props.setApplicationData(applicationInfo);
      let { followupList, ishistory } = this.state;
      if (ishistory) {
        if (!followupList) {
          followupList = await this.getOneNameDicomList(applicationInfo);
        }
        let studies = [];
        for (let i = 0; i < followupList.length; i++) {
          const simpleStudy = await retrieveStudiesMetadata(
            server,
            [followupList[i].studyUid],
            [followupList[i].seriesUid],
            [followupList[i].sopInstanceId]
          );
          simpleStudy[0].studyDate = followupList[i].studyDate;
          studies.push(simpleStudy[0]);
        }
        this.setStudies(studies);
      } else {
        this.getReportStudies(applicationInfo);
        this.getOneNameDicomList(applicationInfo);
      }
    } else {
      let ids = this.props.applicationInfo;
      ids.subVos = ids.subVos || [];
      try {
        let studies = [];
        for (let i = 0; i < ids.subVos.length; i++) {
          if (ids.subVos[i].selectFlag || from === 'screening') {
            const simpleStudy = await retrieveStudiesMetadata(
              server,
              [ids.studyUid],
              [ids.subVos[i].seriesUid],
              [ids.subVos[i].sopInstanceId]
            );
            studies.push(simpleStudy[0]);
          }
        }

        this.setStudies(studies);
      } catch (err) {
        this.setState({ error: true });

        // TODO: Handle gracefully instead of throwing?
        throw new Error(err);
      }
    }
  }

  getApplicationInfo = async () => {
    const { applicationId } = this.state;
    let ids = {};
    await apis.applicationInfo(applicationId).then(res => {
      if (res.code === '0') ids = res.data;
    });
    this.setState({ applicationInfo: ids });
    return ids;
  };
  getReportStudies = async info => {
    const { server } = this.props;
    const { applicationInfo } = this.state;
    const ids = info ? info : applicationInfo;
    try {
      let studies = [];
      const subVos = ids.subVos || [];
      for (let i = 0; i < subVos.length; i++) {
        if (subVos[i].selectFlag) {
          const simpleStudy = await retrieveStudiesMetadata(
            server,
            [subVos[i].studyUid],
            [subVos[i].seriesUid],
            [subVos[i].sopInstanceId]
          );
          studies.push(simpleStudy[0]);
        }
      }
      this.setStudies(studies);
    } catch (err) {
      this.setState({ error: true });

      // TODO: Handle gracefully instead of throwing?
      throw new Error(err);
    }
  };
  getOneNameDicomList = async info => {
    //获取随访记录
    const { applicationInfo } = this.state;
    const ids = info ? info : applicationInfo;
    const id = ids.diagId;
    if (!id) return;
    //获取随访记录
    let followupList = [];
    await apis.oneNameDicomList(id).then(res => {
      if (res.code === '0') {
        followupList = res.data;
        const len = followupList.length;
        this.setState({ followupList, followupLen: len });
      }
    });
    return followupList;
  };

  followupVisibleCallBack = async state => {
    this.setState({ followupVisible: state });
    const { layout } = this.props;
    for (let i = 0; i < layout.viewports.length; i++) {
      this.props.setViewportSpecificData(i, {});
    }
    let url = window.location.href;
    if (state) {
      if (url.indexOf('&ishistory=true') === -1) {
        url += `&ishistory=true`;
        window.location.href = url;
      }
    } else {
      const index = url.indexOf('&ishistory=true');
      if (index > -1) {
        url = url.substring(0, index);
        window.location.href = url;
      }
    }
  };
  setStudies = (studies, type) => {
    // Render the viewer when the data is ready
    // TODO: CLEAR THIS SOMEWHERE ELSE
    studyMetadataManager.purge();

    // Map studies to new format, update metadata manager?
    const updatedStudies = studies.map(study => {
      const studyMetadata = new OHIFStudyMetadata(
        study,
        study.studyInstanceUid
      );
      const sopClassHandlerModules =
        extensionManager.modules['sopClassHandlerModule'];

      study.displaySets =
        study.displaySets ||
        studyMetadata.createDisplaySets(sopClassHandlerModules);
      studyMetadata.setDisplaySets(study.displaySets);

      // Updates WADO-RS metaDataManager
      updateMetaDataManager(study);

      studyMetadataManager.add(studyMetadata);
      return study;
    });
    updatedStudies[0].displaySets[0].studyDate = updatedStudies[0].studyDate;
    const newUpdatedStudies = [updatedStudies[0]];
    for (let i = 1; i < updatedStudies.length; i++) {
      if (
        updatedStudies[i].studyInstanceUid ===
        updatedStudies[i - 1].studyInstanceUid
      ) {
        newUpdatedStudies.forEach(item => {
          if (item.studyInstanceUid === updatedStudies[i].studyInstanceUid) {
            updatedStudies[i].displaySets[0].studyDate =
              updatedStudies[i].studyDate;
            item.displaySets.push(updatedStudies[i].displaySets[0]);
          }
        });
      } else {
        updatedStudies[i].displaySets[0].studyDate =
          updatedStudies[i].studyDate;
        newUpdatedStudies.push(updatedStudies[i]);
      }
    }

    this.setState({ studies: newUpdatedStudies });
  };
  render() {
    if (this.state.error) {
      console.log('error2');
      return (
        <ImageError title="因影像格式有异常，无法查看。如需帮助，请联系在线客服" />
      );
    }
    return (
      <ConnectedViewer
        studies={this.state.studies}
        studyInstanceUids={this.props.studyInstanceUids}
        seriesInstanceUids={this.props.seriesInstanceUids}
        sopInstanceUids={this.props.sopInstanceUids}
        detailList4StudyImgList={this.state.detailList4StudyImgList}
        tubeStudyDetail={this.state.tubeStudyDetail}
        applicationInfo={this.state.applicationInfo}
        // followupClicked={this.followupClicked}
        followupVisibleCallBack={this.followupVisibleCallBack}
        followupList={this.state.followupList}
        followupLen={this.state.followupLen}
      />
    );
  }
}

export default ViewerRetrieveStudyData;
